import React from "react";
import { NextPage } from "next";
import { Header } from "@components";
import Head from "next/head";
import { CLogin, CreateCompetition } from "@components/competition";
import { getCookie } from "@util/cookies";
import { useToast } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { IUser } from "@redux/slices/user";
import { useSelector } from "react-redux";

const CreateCompetitionPage: NextPage = () => {
    const accessToken = getCookie("re_auth_access_token");
    const toast = useToast();
    const router = useRouter();
    const user = useSelector((state: { user: IUser }) => state.user);

    return (
        <>
            <Head>
                <title>RoboEpics | ایجاد مسابقه‌/کلاس درس</title>
                <meta name="viewport" content="initial-scale=1.0, width=device-width" />
            </Head>
            <Header toast={toast} router={router} user={user} />
            {accessToken ? (
                <CreateCompetition toast={toast} router={router} />
            ) : (
                <CLogin text={"برای ایجاد مسابقه یا کلاس درس باید وارد حساب کاربری خود شوید"} />
            )}
        </>
    );
};

export default CreateCompetitionPage;
